     <template>
  <div class="market-GCBR-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #storeRefId="{ row }">{{ row.storeRefId }}</template>
      <template #financeName="{ row }">{{ row.financeName}}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #storeName="{ row }">{{ row.storeName}}</template>
      <template #totalDealAmount="{ row }">{{ row.totalDealAmount}}</template>
      <template #alipayPayAmount="{ row }">{{ row.alipayPayAmount }}</template>
      <template #totalStoredCardAmount="{ row }">{{ row.totalStoredCardAmount }}</template>
      <template #wechatPayAmount="{ row }">{{ row.wechatPayAmount }}</template>
      <template #creditPayAmount="{ row }">{{ row.creditPayAmount}}</template>
      <template #totalRefundAmount="{ row }">{{ row.totalRefundAmount}}</template>
      <template #wechatRefundAmount="{ row }">{{ row.wechatRefundAmount}}</template>
      <template #creditRefundAmount="{ row }">{{ row.creditRefundAmount }}</template>
      <template #totalRetainedDealAmount="{ row }">{{ row.totalRetainedDealAmount }}</template>
      <template #totalIncomeAmount="{ row }">{{ row.totalIncomeAmount}}</template>
      <template #totalCommission="{ row }">{{ row.totalCommission }}</template>
      <template #wechatCommission="{ row }">{{ row.wechatCommission}}</template>
      <template #creditCommission="{ row }">{{ row.creditCommission}}</template>
      <template #totalRentDeductionAmount="{ row }">{{ row.totalRentDeductionAmount}}</template>
      <template #totalWithdrawalCommission="{ row }">{{ row.totalWithdrawalCommission}}</template>
      <template #totalDealCount="{ row }">{{ row.totalDealCount}}</template>
      <template #totalRefundCount="{ row }">{{ row.totalRefundCount}}</template>
      <template #totalRetainedDealCount="{ row }">{{ row.totalRetainedDealCount}}</template>
      <template #totalDiscountAmount="{ row }">{{ row.totalDiscountAmount}}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { downFile } from "@/utils";
import {api_getStoreFinancialDetailList,api_postStoreFinancialDetailExport} from '@/api/finance'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mcheckGCBRIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "选择日期",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
        },
        {
          label: "店铺名称",
          type: "choose-store",
          key: "storeId",
        },
        {
          label: "商场名称",
          placeholder: '请选择商场名称',
          type: "mall",
          key: "mallId",
        }
        
      ],
      form: {},
      tableKey: false,
      exportLoading: false,
      tableThData: [
        { prop: "storeRefId", label: "店铺编号", minWidth: "150", },
        { prop: "financeName", label: "主体名称", minWidth: "180", },
        { prop: "mallName", label: "商场名称", minWidth: "180", },
        { prop: "storeName", label: "店铺名称", minWidth: "180", },
        { prop: "alipayPayAmount", label: "支付宝支付总额(元)", minWidth: "150", },
        { prop: "totalStoredCardAmount", label: "储值卡支付总额(元)", minWidth: "150", },
        { prop: "totalDealAmount", label: "成交订单总额(元)", minWidth: "150", },
        { prop: "wechatPayAmount", label: "微信支付总额(元)", minWidth: "150", },
        { prop: "creditPayAmount", label: "信用卡分期总额(元)", minWidth: "150", },
        { prop: "totalRefundAmount", label: "退款订单总额(元)", minWidth: "150", },
        { prop: "wechatRefundAmount", label: "微信退款订单总额(元)", minWidth: "180", },
        { prop: "creditRefundAmount", label: "信用卡退款订单总额(元)", minWidth: "180", },
        { prop: "totalRetainedDealAmount", label: "净成交总额(元)", minWidth: "120", },
        { prop: "totalIncomeAmount", label: "应实收总额(元)", minWidth: "120", },
        { prop: "totalCommission", label: "交易手续费总额(元)", minWidth: "150", },
        { prop: "wechatCommission", label: "微信手续费总额(元)", minWidth: "150", },
        { prop: "creditCommission", label: "信用卡分期手续费总额(元)", minWidth: "200", },
        { prop: "totalRentDeductionAmount", label: "租金扣点总额(元)", minWidth: "150", },
        { prop: "totalDealCount", label: "订单交易总数(笔)", minWidth: "150", },
        { prop: "totalRefundCount", label: "退款订单总数(笔)", minWidth: "150", },
        { prop: "totalRetainedDealCount", label: "净成交总数(笔)", minWidth: "120", },
        { prop: "totalDiscountAmount", label: "优惠总额(元)", minWidth: "120", },
      ],

    };
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.created && newParams.created.length > 0){
        newParams.startTime = +new Date(newParams.created[0])
        newParams.endTime = +new Date(newParams.created[1])
      }
      delete newParams.created
      const data = await api_getStoreFinancialDetailList(newParams)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    
    },
    //导出
     async onExport() {
      this.exportLoading = true
      let params = {
        mallId: this.form.mallId || [],
        storeId: this.form.storeId || [],
      }
      if(this.form.created && this.form.created.length > 0){
        params.startTime = +new Date(this.form.created[0])
        params.endTime = +new Date(this.form.created[1])
      }
      let res = await api_postStoreFinancialDetailExport(params) // 交易明细 （列表）
      downFile(res) // 导出交交易明细
      this.exportLoading = false
    },

  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-GCBR-index {
  width: 100%;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>